import { render, staticRenderFns } from "./FreeTextQuestion.vue?vue&type=template&id=cf4886f8&"
import script from "./FreeTextQuestion.vue?vue&type=script&lang=js&"
export * from "./FreeTextQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports